// chakra imports
import { Box, Flex, Stack, Button, Text, useColorModeValue, Divider } from "@chakra-ui/react";
//   Custom components
import Brand from "components/sidebar/components/Brand";
import Links from "components/sidebar/components/Links";
import React from "react";
import { useNavigate } from "react-router-dom";
import { Icon } from "@chakra-ui/react";
import { MdLogout } from "react-icons/md";
// Services
import { logout, getCurrentUser } from "services/authService";

// FUNCTIONS

function SidebarContent(props) {
  const { routes } = props;
  const navigate = useNavigate();
  
  // Chakra Color Mode
  const textColorSecondary = useColorModeValue('secondaryGray.600', 'white');
  const borderColor = useColorModeValue('secondaryGray.200', 'whiteAlpha.100');
  const buttonHover = useColorModeValue({ bg: 'red.100' }, { bg: 'red.800' });
  const buttonText = useColorModeValue('red.600', 'red.300');
  
  // Get current user
  const currentUser = getCurrentUser();
  const userName = currentUser?.name || currentUser?.email || 'User';

  // Handle logout
  const handleLogout = () => {
    logout();
    navigate('/auth/sign-in');
  };

  // SIDEBAR
  return (
    <Flex direction='column' height='100%' pt='25px' px="16px" borderRadius='30px'>
      <Brand />
      <Stack direction='column' mb='auto' mt='8px' flex='1'>
        <Box ps='20px' pe={{ md: "16px", "2xl": "1px" }}>
          <Links routes={routes} />
        </Box>
      </Stack>
      
      {/* Sign Out Section */}
      <Box mt='auto' pb='20px' ps='20px' pe={{ md: "16px", "2xl": "1px" }}>
        <Divider borderColor={borderColor} mb='15px' />
        <Flex direction='column' gap='10px'>
          <Text color={textColorSecondary} fontSize='xs' fontWeight='500' px='10px'>
            {userName}
          </Text>
          <Button
            onClick={handleLogout}
            leftIcon={<Icon as={MdLogout} />}
            colorScheme='red'
            variant='ghost'
            size='sm'
            w='100%'
            justifyContent='flex-start'
            color={buttonText}
            _hover={buttonHover}
            _active={buttonHover}
          >
            Sign Out
          </Button>
        </Flex>
      </Box>
    </Flex>
  );
}

export default SidebarContent;
